export const OPSTARTPLAN_QUERY_KEY = "opstartplan";
